export default function download (obj: Blob | MediaSource, name: string) {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(obj)
  link.download = name
  link.click()
}
